import { features } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

export default function Features() {
  return (
    <section id="feature" className="relative overflow-hidden bg-foreground-950 py-14 md:py-24" aria-labelledby="feature-title">
      <div
        className="pointer-events-none absolute -right-40 -top-40 h-96 w-96 rounded-full opacity-20 blur-3xl"
        style={{ backgroundColor: 'oklch(var(--primary-500))' }}
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -bottom-48 -left-24 h-96 w-96 rounded-full opacity-15 blur-3xl"
        style={{ backgroundColor: 'oklch(var(--accent-500))' }}
        aria-hidden="true"
      />

      <div className="relative mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Editor&apos;s Choice"
          title="编辑精选 · 把瓜吃深一点"
          desc="不止于速递，更想和你一起把事件讲清楚。年度盘点、深度观察与产业前瞻，值得你静下来慢慢读的栏目。"
          light
        />

        <div className="space-y-5">
          {features.map((f, i) => (
            <article
              key={f.id}
              className="group grid grid-cols-1 overflow-hidden rounded-2xl border border-background-50/10 bg-background-50/5 backdrop-blur transition-colors hover:border-background-50/20 lg:grid-cols-2"
            >
              <div className={`relative aspect-[16/9] w-full overflow-hidden lg:aspect-auto ${i % 2 === 1 ? 'lg:order-2' : ''}`}>
                <img
                  src={f.img}
                  alt={f.alt}
                  title={`${f.title} - 吃瓜视界编辑精选`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">{f.eyebrow}</span>
              </div>
              <div className={`flex flex-col justify-center p-6 md:p-9 ${i % 2 === 1 ? 'lg:order-1' : ''}`}>
                <span className="font-mono text-xs font-semibold uppercase tracking-widest text-accent-400">Special {String(i + 1).padStart(2, '0')}</span>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">{f.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-background-50/70 md:text-base">{f.desc}</p>
                <div className="mt-6 flex items-center gap-3">
                  <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50/10 px-4 py-2 text-sm font-semibold text-background-50">
                    <i className="ri-book-open-line" style={{ width: 15, height: 15 }} />
                    编辑专栏
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-background-50/60">
                    <i className="ri-eye-line" style={{ width: 14, height: 14 }} />
                    {f.reads}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}